import { ref, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'
import type { AuthLogin } from '../entities/AuthLogin'
import type { AuthUser } from '../entities/AuthUser'
import { useUserStore } from '../stores/userStore'

export function useLoginComposable() {
  const RenderAuthLoginInstance: Ref<AuthLogin> = ref(null)
  // @ts-ignore
  const RenderAuthUserInstance: Ref<AuthUser> = ref(null)
  const userStore = useUserStore()

  const unsubscribe = userStore.$subscribe(() => {
    init()
  })

  onUnmounted(() => {
    unsubscribe()
  })

  function init() {
    if (userStore.getLogged === true) {
      initLogout()
    } else if (userStore.getLogged === false) {
      initLogin()
    }
  }

  function initLogin() {
    // @ts-ignore
    RenderAuthUserInstance.value = null

    RenderAuthLoginInstance.value = {
      urlLoginButton: routes().login(),
    }

    window.rurality.auth.GoogleIdentityService.onLoginInit()
  }

  function getRenderAuthUser(rawRenderAuthUser: AuthUser<any>): AuthUser<any> {
    const parsedData = {
      logged: rawRenderAuthUser.logged,
      avatar: rawRenderAuthUser.avatar,
      name: rawRenderAuthUser.name,
      mail: rawRenderAuthUser.mail,
      show_unread: false,
    }

    if (
      rawRenderAuthUser?.params?.unread_bookings > 0 ||
      rawRenderAuthUser?.params?.unread_messages > 0
    ) {
      parsedData.show_unread = true
    }

    return parsedData
  }

  function initLogout() {
    RenderAuthLoginInstance.value = null
    RenderAuthUserInstance.value = getRenderAuthUser(userStore.getUserdata)
  }

  onMounted(() => {
    init()
  })

  return { RenderAuthLoginInstance, RenderAuthUserInstance }
}
